<template>
  <section class="section">
    <div class="container"><h1 class="title">Statements</h1></div>
  </section>
</template>

<script>
export default {
  name: 'Statements'
};
</script>
